{
  "steplist": "Seznam korakov"
}
